import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
                'Kod',
                'Ad',
                'Turu',
            ]);
            return dataSource;
    }

}
